import { render, staticRenderFns } from "./carga-masiva.vue?vue&type=template&id=4e07cccd&"
import script from "./carga-masiva.component.ts?vue&type=script&lang=ts&"
export * from "./carga-masiva.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports